import Vue from "vue"
import Vuelidate from 'vuelidate'
import _ from 'lodash';
import vuetify from './plugins/vuetify';
import App from "./App.vue"
import {router} from './router/index'
import { store } from './store/store'
import http from './config/axios_config'
import metricHelper from './js/metrics'
import accessControl from './js/accessControl'
import moment from 'moment'
import CoDash from './js/CoDash'
import cmath from './js/cmath'
import './components/global'
// import "./registerServiceWorker"
import themes from './js/themes'

// CSS imports
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
// import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
import './assets/css/main.scss' // Import this last so it overwrites vuetify defaults

Vue.config.productionTip = false;

Vue.prototype.$crx = {}
Vue.prototype.$crx.metrics = metricHelper // attach global static vars
Vue.prototype.$accessControl = accessControl
Vue.prototype.$moment = moment
Vue.prototype.$axios = http
Vue.prototype.$codash = CoDash
Vue.prototype.$_ = _
Vue.prototype.$cmath = cmath

Vue.use(Vuelidate)
Vue.use(require('vue-shortkey'))

/* Vue.use(Vuetify, {
  theme: themes[store.state.theme].vuetifyTheme,
  options: {
    customProperties: true
  }
}) */
new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
